import { render, staticRenderFns } from "./GradeWarnModel.vue?vue&type=template&id=45b2e608&scoped=true&xmlns%3A=true"
import script from "./GradeWarnModel.vue?vue&type=script&lang=js"
export * from "./GradeWarnModel.vue?vue&type=script&lang=js"
import style0 from "./GradeWarnModel.vue?vue&type=style&index=0&id=45b2e608&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2e608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b2e608')) {
      api.createRecord('45b2e608', component.options)
    } else {
      api.reload('45b2e608', component.options)
    }
    module.hot.accept("./GradeWarnModel.vue?vue&type=template&id=45b2e608&scoped=true&xmlns%3A=true", function () {
      api.rerender('45b2e608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/GradeWarnModel.vue"
export default component.exports